import { getClient } from '../client.js';
import { executeSteps, APIError, adaptViemWallet, getCurrentStepData } from '../utils/index.js';
import axios from 'axios';
import { zeroAddress } from 'viem';
import { isViemWalletClient } from '../utils/viemWallet.js';
/**
 * Swap crosschain using Relay
 * @param data.chainId destination chain id
 * @param data.wallet Wallet object that adheres to the AdaptedWakket interface or a viem WalletClient
 * @param data.originChainId The chain to pay the solver on
 * @param data.precheck Set to true to skip executing steps and just to get the initial steps required
 * @param data.options - {@link SwapBodyOptions}
 * @param data.onProgress Callback to update UI state as execution progresses
 */
export async function swap(data) {
    const { toChainId, toCurrency, wallet, chainId, currency, amount, recipient, options, onProgress = () => { }, precheck, depositGasLimit } = data;
    const client = getClient();
    if (!client.baseApiUrl || !client.baseApiUrl.length) {
        throw new ReferenceError('RelayClient missing api url configuration');
    }
    let adaptedWallet;
    let caller;
    if (wallet) {
        adaptedWallet = isViemWalletClient(wallet)
            ? adaptViemWallet(wallet)
            : wallet;
        caller = await adaptedWallet.address();
    }
    // Ensure wallet is provided when precheck is false or undefined
    if (!precheck && !adaptedWallet) {
        throw new Error('Wallet is required when precheck is false or not provided.');
    }
    try {
        const data = {
            user: caller || zeroAddress,
            destinationCurrency: toCurrency,
            destinationChainId: toChainId,
            originCurrency: currency,
            originChainId: chainId,
            amount,
            recipient: recipient ? recipient : caller ?? zeroAddress,
            tradeType: options?.tradeType ?? 'EXACT_INPUT',
            source: client.source || undefined,
            ...options
        };
        const request = {
            url: `${client.baseApiUrl}/execute/swap`,
            method: 'post',
            data
        };
        if (precheck) {
            const res = await axios.request(request);
            if (res.status !== 200)
                throw new APIError(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress({
                steps: data['steps'],
                fees: data['fees'],
                breakdown: data['breakdown'],
                details: data['details']
            });
            return data;
        }
        else {
            if (!adaptedWallet) {
                throw new Error('AdaptedWallet is required to execute steps');
            }
            await executeSteps(chainId, request, adaptedWallet, ({ steps, fees, breakdown, details }) => {
                const { currentStep, currentStepItem, txHashes } = getCurrentStepData(steps);
                onProgress({
                    steps,
                    fees: fees,
                    breakdown,
                    details,
                    currentStep,
                    currentStepItem,
                    txHashes
                });
            }, undefined, depositGasLimit
                ? {
                    deposit: {
                        gasLimit: depositGasLimit
                    }
                }
                : undefined);
            return true;
        }
    }
    catch (err) {
        console.error(err);
        throw err;
    }
}
//# sourceMappingURL=swap.js.map